import axios from "axios";

const producao =
  window.location.href.indexOf("app.motorfiscal") != -1 ? true : false;
const url = producao
  ? "https://apiv2.motorfiscal.com.br"
  : "https://apiv2homolog.motorfiscal.com.br";

export async function getDocumentoManifesto(empresaId, json, token) {
  try {
    const response = await axios.post(
      `${url}/manifestacao/pdf/${empresaId}`,
      json,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/domain/notas/manifesto/colunaManifestoService.js